<script lang="ts">
    import { dictionary } from "@app/services/currentDictionary.service";
    import {
        FORM__phraseHintAllUppercase,
        FORM__phraseHintFirstUppercase,
        FORM__phraseHintHasDef,
        FORM__phraseHintHasMulti,
        FORM__phraseHintHasPrefix,
        FORM__turnLowercase,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import InlineMessage from "../InlineMessage.svelte";
    type PhraseHintType =
        | "uppercase"
        | "firstUppercase"
        | "hasDef"
        | "hasMulti"
        | "hasEnglishPrefix";

    export let inputPhrase: string;
    export let inputPhraseToLowercase: () => void;

    let hintToShow: PhraseHintType | undefined;

    let prevP1 = inputPhrase;
    $: {
        if (prevP1 !== inputPhrase) {
            prevP1 = inputPhrase;
            const phrase = prevP1.trim();
            const phraseTrimmStart = prevP1.trimStart();
            hintToShow = undefined;

            if (phrase && phrase.length > 0) {
                if (phrase === phrase.toUpperCase()) {
                    hintToShow = "uppercase";
                } else if (
                    phrase.charAt(0) === phrase.charAt(0).toUpperCase()
                ) {
                    hintToShow = "firstUppercase";
                } else if (phrase.indexOf("(") !== -1) {
                    hintToShow = "hasDef";
                } else if (
                    phrase.indexOf(",") !== -1 ||
                    phrase.indexOf(";") !== -1
                ) {
                    hintToShow = "hasMulti";
                } else if (
                    ($dictionary.l1.code === "en" ||
                        $dictionary.l2.code === "en") &&
                    (phraseTrimmStart.startsWith("a ") ||
                        phraseTrimmStart.startsWith("an ") ||
                        phraseTrimmStart.startsWith("to "))
                ) {
                    // stupid heuristics here, we don't know really if p1 is en, but let's assume it is
                    hintToShow = "hasEnglishPrefix";
                }
            }
        }
    }
</script>

{#if hintToShow}
    <InlineMessage messageType="warn">
        {#if hintToShow === "uppercase"}
            {getMessage(FORM__phraseHintAllUppercase)}
        {:else if hintToShow === "firstUppercase"}
            {getMessage(FORM__phraseHintFirstUppercase)}
        {/if}
        {#if hintToShow === "uppercase" || hintToShow === "firstUppercase"}
            <div class="text-center p-2">
                <button
                    type="button"
                    class="button-xs"
                    on:click={inputPhraseToLowercase}
                    >{getMessage(FORM__turnLowercase)}
                </button>
            </div>
        {/if}
        {#if hintToShow === "hasDef"}
            {getMessage(FORM__phraseHintHasDef)}
        {/if}
        {#if hintToShow === "hasMulti"}
            {getMessage(FORM__phraseHintHasMulti)}
        {/if}

        {#if hintToShow === "hasEnglishPrefix"}
            {getMessage(FORM__phraseHintHasPrefix)}
        {/if}
    </InlineMessage>
{/if}
